module.exports = require('./helpers/bundle-url').getBundleURL('8mUD3') + "logo.c51670a8.svg";